import axios from "axios"
import { useState } from "react";
import { baseUrl } from "../URL"

export const signin = async (values) => {
   return await axios.post(baseUrl("login"),values)
}